module.exports = __webpack_public_path__ + "static/media/MeltyCheese.31b5f7d4.svg";